import BaseComponent from "../../baseComponent.js";
import styles from "../../common/tab.scss";

export default class TabItem extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleClick() {
    this.props.onTabClick(this.props.tab.id);
  }

  render() {
    let titleStyle = this.props.tab.activated ? styles.activatedTitle : styles.title;
    let classes = "tab-item__title", style = {padding: "6px 0"};
    if (this.props.tab.isActive) {
      classes += " tab-item--active";
    }
    return (
      <div className="tab-item col s6 m6" ref="tab" style={style}>
        <div style={{display: "flex"}}>
          <div className={titleStyle} ref="title" style={{width: "240px"}}
               onClick={this.handleClick}>
            {this.props.tab.title}
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/profile/tab/tabItem.jsx